<template>
  <div class="c-card elevation-2" style="height: 100%;">
    <v-layout align-center class="crx-toolbar subheading pa-2 pl-4 text-xs-center">
      Inventory at location
    </v-layout>

    <row 
    v-for="item of inventory" 
    :key="item.id"
    :item="item"
    @editQuantity="editQuantity(item.id)">
    </row>

    <!-- DIALOGS -->
    <edit-quantity-dialog ref="editQuantityDialog"></edit-quantity-dialog>

  </div>
</template>

<script>
import EditQuantityDialog from '@/components/v/inventory/edit-inv-quantity-dialog'
import Row from './row'

export default {
  props: ['archiveItem'],
  components: {
    EditQuantityDialog,
    Row
  },
  computed: {
    inventory () {
      return Object.values(this.$store.state.db.inventory.inventory).filter(item => item.archive_id === this.archiveItem.id)
    },
    totalInStock () {
      return this.inventory.reduce((a, i) => {
        return a += i.quantity
      }, 0)
    }
  },
  methods: {
    editQuantity (id) {
      this.$refs.editQuantityDialog.open(id)
    }
  }
}
</script>
